export const typography = {
  fonts: {
    heading: `Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    mono: `SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`, // Monospaced for code/identifiers
  },
  fontSizes: {
    '3xs': '0.65rem', // 9px
    '2xs': '0.7rem', // 10px
    xs: '0.75rem', // 12px
    xsm: '0.8125rem', // 13px
    sm: '0.875rem', // 14px
    smd: '0.9375rem', // 15px
    md: '1rem', // 16px (base text)
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px (small heading)
    '3xl': '1.875rem', // 30px (section heading)
    '4xl': '2.25rem', // 36px (page title)
    '5xl': '3rem', // 48px
    '6xl': '3.75rem', // 60px
    '7xl': '4.5rem', // 72px
    '8xl': '6rem', // 96px
    '9xl': '8rem', // 128px
  },
  fontWeights: {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  lineHeights: {
    shorter: 1.25, // Compact text
    short: 1.375, // Slightly compact
    normal: 1.5, // Default line height
    tall: 1.625, // Relaxed text
    taller: 2, // Very relaxed
  },
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
};
